const updateOrAddElement = (array, callTask) => {
  if (!array.length)
    return [callTask];
  return array.reduce((accumulator, current, index, arr) => {
    if (callTask.referenceId === current.referenceId)
      return [...accumulator, callTask];
    if (!accumulator.length && index === arr.length - 1) {
      return [callTask, ...accumulator, current];
    }
    return [...accumulator, current];
  }, []);
};
export {
  updateOrAddElement
};
